import React from 'react';

const Emptytag = () => {
  return <></>;
};

export default Emptytag;
